class LegalTabs extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.tabs = [...this.querySelectorAll('.PageContent__NavItem')];
    this.panels = [...this.querySelectorAll('.PageContent__ContentItem')];

    if (!this.tabs.length) return;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.#activate(index), { signal });
    });

    const hashIndex = parseInt(window.location.hash.replace('#', ''), 10) - 1;
    const initialIndex = hashIndex >= 0 && hashIndex < this.tabs.length ? hashIndex : 0;
    this.#activate(initialIndex);
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #activate(index) {
    this.tabs.forEach((tab, i) => tab.setAttribute('aria-selected', String(i === index)));
    this.panels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
    this.tabs[index]?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }
}

if (!customElements.get('legal-tabs')) {
  customElements.define('legal-tabs', LegalTabs);
}
